const it = {
  welcome_to_agami: 'Benvenut* su Agami Route',
  login: 'ACCEDI',
  send_email: 'INVIA EMAIL',
  login_with_password: 'Accedi con password',
  login_with_email: 'Accedi solo con email',
  lang: 'Italiano',
  select_lang: 'Seleziona la tua lingua',
  day: 'Giorno',
  night: 'Notte',
  confirm: 'Conferma',
  continue: 'Continua',
  cancel: 'Annulla',
  refresh: 'Ricarica',
  yes_continue: 'Sì, continua',
  start: 'Inizia',
  back: 'Indietro',
  wait: 'Attendere prego...',
  headset: "Utilizza le cuffie fornite per un'esperienza migliore",
  raise_volume: 'Aumenta il volume del dispositivo',
  sound: 'Senti il suono correttamente?',
  wait_location: "Controllo dell'accuratezza della posizione",
  gps: "L'app sta cercando di ottenere la tua posizione",
  gps_error: "C'è un problema con il GPS di questo telefono",
  gps_quality_bad: 'Precisione della posizione scarsa',
  gps_quality_bad_details: 'Potresti riscontrare problemi con la riproduzione automatica',
  gps_quality_average: 'Precisione della posizione accettabile',
  gps_quality_good: 'Precisione della posizione ottima',
  cookies: "C'è già un tour in corso",
  cookies_action: 'Desideri continuare o ricominciare?',
  cookies_delete: 'Cambia esperienza',
  cookies_maintain: 'Continua esperienza',
  unlocking: "Se hai bisogno di utilizzare l'app durante la visita, sbloccala utilizzando questo codice",
  unlock: 'Conferma lo sblocco?',
  unlock_subtitle: 'Lo sblocco dello schermo è solo per gli amministratori',
  areyouready: 'Si comincia!',
  welcome: 'BENVENUTƏ',
  map: 'Mappa',
  code: 'Contenuti',
  insert_code: 'Inserisci il riferimento del contenuto e premi "Riproduci"',
  faq: [
    {
      q: 'Problemi di connessione?',
      a: 'Se riscontri problemi di connessione, prova a...',
    },
    {
      q: 'Altre domande frequenti',
      a: 'Se riscontri problemi di connessione, prova a...',
    },
  ],
  mobile_only: 'Questa app è stata progettata solo per dispositivi mobili.',
  screen_locked: 'Schermo bloccato',
  swipe_left: 'Scorri a sinistra per sbloccare',
  admin_title: 'Controlli amministratore',
  admin_close: 'Chiudi',
  admin_test: 'Test audio',
  admin_reset_soft: 'Cambia esperienza',
  admin_reset_hard: "Reset dell'app",
  admin_reset_hard_confirm: "Vuoi resettare l'app?",
  admin_reset_hard_desc:
    "Il reset dell'app cancellerà tutte le esperienze salvate e i loro contenuti. Dovrai scaricarli nuovamente.",
  admin_logout: 'Logout',
  admin_logout_confirm: 'Logout?',
  admin_logout_desc: 'Dovrai scansionare il QR o inserire le credenziali per accedere di nuovo.',
  search_gps: 'In attesa della copertura GPS',
  select_experience: "Seleziona un'esperienza",
  no_experience: 'Sembra che tu non abbia nessuna esperienza disponibile.',
  pause: 'Pausa',
  stop: 'Stop',
  stop_all: 'Stoppa tutto',
  close: 'Chiudi',
  no_description: 'Nessuna descrizione',
  stop_video: 'Interrompi la riproduzione video',
  restart: 'Riprendi',
  beforestart: 'Tocca il pulsante "Inizia" per iniziare l\'esperienza.',
  ispause: 'ESPERIENZA IN PAUSA',
  ispause_restart: 'Fai clic sul pulsante "Riproduci" per riprenderla.',
  play: 'Riproduci',
  audio_ready: 'agami attivo! Premi il pulsante qui sotto per ascoltarlo.',
  offline_experience: 'Esperienza offline',
  replay_title: 'Il contenuto è disponibile per essere riprodotto',
  replay_message: "C'è un contenuto disponibile che hai già ascoltato. Vuoi riprodurlo?",
  redeem_exp_title: 'Ottieni esperienza',
  redeem_exp_result_title: 'Esperienza attivata',
  redeem_exp_button: 'ATTIVA',
  go_to_exp_button: 'INIZIA',
  check_email_login: "Controlla la tua email per confermare l'accesso.",
  redeemed_until_days: 'Hai accesso per i prossimi',
  redeemed_until_date: 'Hai accesso fino al',
  alreadly_redeemed:
    'Sembra che tu abbia già utilizzato questo codice in precedenza. Dovresti già avere questa esperienza.',
  redeem_ok: "L'esperienza è stata creata con successo per te.",

  gps_location_unavailable: 'Servizi di localizzazione non disponibili',
  gps_location_unavailable_desc:
    "I servizi di localizzazione sono disabilitati o non è stato concesso l'accesso. Si prega di seguire le istruzioni su come controllare le impostazioni corrette.",
  gps_location_open_phone_settings: 'Apri le impostazioni del telefono',
  gps_location_browser_in_use: 'il browser che stai utilizzando',

  gps_location_android_1: 'Vai su "Posizione"',
  gps_location_android_2: 'Verifica che "Utilizza posizione" sia abilitato',
  gps_location_android_3: 'Apri "Autorizzazioni posizione app"',
  gps_location_android_4: 'Scorri fino in fondo nella sezione "Non consentite" e controlla se',
  gps_location_android_5: 'è presente',
  gps_location_android_6:
    'Se è il caso, clicca su di esso e seleziona "Chiedi sempre" o "Consenti solo quando si utilizza l\'app"',

  gps_location_ios_1: 'Vai su "Privacy e sicurezza" > "Servizi di localizzazione"',
  gps_location_ios_2: 'Verifica che il servizio di localizzazione sia attivo',
  gps_location_ios_2_1_chrome: "Verifica anche che il servizio sia attivo per Chrome nell'elenco sottostante",
  gps_location_ios_2_1_safari: "Verifica anche che il servizio sia attivo per Safari nell'elenco sottostante",
  gps_location_ios_3: 'Torna alle impostazioni del telefono',
  gps_location_ios_4: 'Scorri verso il basso e cerca le impostazioni di',
  gps_location_ios_5: 'All\'interno delle impostazioni, cerca "Posizione"',
  gps_location_ios_6: 'Impostalo su "Chiedi" o "Consenti"',

  gps_location_chrome_1: 'Apri Chrome',
  gps_location_chrome_2: 'Vai a',
  gps_location_chrome_3:
    "Apri le impostazioni del sito cliccando sull'icona appena a sinistra dell'indirizzo del sito web",
  gps_location_chrome_4: 'Seleziona "Autorizzazioni"',
  gps_location_chrome_5: 'Verifica che "Posizione" sia consentita',

  gps_location_safari_1: 'Apri Safari',
  gps_location_safari_2: 'Vai a',
  gps_location_safari_3:
    'Apri le impostazioni del sito cliccando sull\'icona "Aa" appena a sinistra dell\'indirizzo del sito web',
  gps_location_safari_4: 'Seleziona "Impostazioni del sito web"',
  gps_location_safari_5:
    'Nella sezione "Consenti", verifica che "Posizione" sia impostata su "Chiedi" o "Consenti"',
  gps_location_safari_6: 'Clicca su "Fatto"',

  gps_location_browser_1: 'Apri il browser preferito',
  gps_location_browser_2: 'Vai a',
  gps_location_browser_3: 'Apri le impostazioni del sito web',
  gps_location_browser_4:
    'Verifica che il permesso di accesso alla posizione sia impostato su "Chiedi" o "Consenti"',

  go_without_gps: 'Procedi senza posizione',
  go_without_gps_warning: 'Sarai in grado di riprodurre solo il contenuto inserendo manualmente i codici.',

  read_instructions: 'Leggi le istruzioni',

  go_home: 'Vai alla home',

  multiple_agami_active: 'Più agami attivi',

  pwa_install_cta: 'Goditi la migliore esperienza!',
  pwa_install_description:
    'Installa Agami Route sul tuo dispositivo: è veloce, leggera e funziona come una normale app.',
  install: 'Installa',
  aria_pwa_install_dialog: "Finestra d'installazione di Agami Route",
  aria_dismiss_pwa_install: "Chiudi l'avviso d'installazione",

  unsupported_browser_title: 'Browser non supportato',
  unsupported_browser_description:
    'Su questo browser alcune funzioni essenziali di questa app non funzionano correttamente.',
  unsupported_browser_open_with: 'Per il corretto funzionamento apri questo indirizzo con {browser}',
  copy_address: 'Copia indirizzo',
  address_copied: 'Indirizzo copiato',
  address_copy_error: "Impossibile copiare l'indirizzo",
  understood_continue: 'Ho capito, continuo comunque',
  aria_unsupported_browser_dialog: 'Avviso browser non supportato',

  agami_not_found: 'Nessun agami trovato con questo codice.',
  multiple_agami_found: 'Trovati più agami con questo codice.',

  resume: 'Riprendi',

  qr_scan: 'SCANSIONA QR',
  qr_invalid: 'Codice QR non valido',
  qr_frame_instruction: 'Inquadra il codice QR entro i bordi bianchi',

  text_size: 'DIMENSIONE DEL TESTO',
  standard: 'Standard',
  large: 'Grande',
  xlarge: 'Molto grande',

  aria_select_experience: 'Seleziona esperienza',
  aria_download_experience: 'Scarica esperienza',
  aria_download_experience_in_progress: "Download dell'esperienza {experience}",
  aria_cancel_download: 'Annulla download',
  aria_refresh_experience: 'Aggiorna esperienza',
  aria_next_element: 'Elemento successivo',
  aria_previous_element: 'Elemento precedente',
  aria_open_language: 'Apri selezione lingua',
  aria_close_language: 'Chiudi selezione lingua',
  aria_open_font_size: 'Apri selezione dimensione testo',
  aria_close_font_size: 'Chiudi selezione dimensione testo',
  aria_activate_dark_theme: 'Tema attuale: giorno. Attiva per passare al tema notte',
  aria_activate_light_theme: 'Tema attuale: notte. Attiva per passare al tema giorno',
  aria_rewind_10_secs: 'Riavvolgi di 10 secondi',
  aria_fast_forward_10_secs: 'Avanza di 10 secondi',
  aria_open_audio_player: 'Apri il lettore audio',
  aria_close_audio_player: 'Chiudi il lettore audio',
  aria_audio_player_dialog: 'Finestra audio attivo',
  aria_audio_playback_progress: 'Progresso della riproduzione audio',
  aria_audio_elapsed_time: 'Tempo trascorso {elapsed}, su una durata totale di {total}',
  aria_login_with_email_only: 'Passa a modalità di accesso solo con email',
  aria_login_with_email_password: 'Passa a modalità di accesso con email e password',
  aria_offline_mode: 'Accedi alla modalità offline',
  aria_send_otp_email: 'Invia email per accesso',
  aria_show_password: 'Mostra password',
  aria_hide_password: 'Nascondi password',
  aria_open_qr_scanner: 'Apri scanner QR',
  aria_close_qr_scanner: 'Chiudi scanner QR',
  aria_qr_panel: 'Pannello scanner QR',
  aria_qr_scanner_preview: 'Anteprima fotocamera dello scanner QR',
  aria_manual_playback_code_input: 'Codice di riproduzione manuale',
  aria_start_manual_content: 'Avvia contenuto manuale',
  aria_redeem_experience: 'Attiva esperienza',
  aria_experience_redeem_code_input: 'Codice di attivazione esperienza',
  aria_loading: 'Caricamento',
  aria_go_to_experience: "Vai all'esperienza",
  aria_manual_playback_code_dialog: 'Finestra inserimento codice di riproduzione manuale',
  aria_replay_content_dialog: 'Finestra per riascolto del contenuto',
  aria_open_video_player: 'Apri il lettore video',
  aria_close_video_player: 'Chiudi il lettore video',
  aria_active_video_dialog: 'Finestra video attivo',
  aria_collapsed_video_player: 'Lettore video ridotto',
  aria_collapse_video_player: 'Riduci il lettore video',
  aria_expand_video_player: 'Espandi il lettore video',
  aria_open_controls_menu: 'Apri menu controlli',
  aria_close_controls_menu: 'Chiudi menu controlli',
  aria_onboarding_step_sentence: 'Passaggio di onboarding numero {current} di {total}',

  experience_redeemed_successfully: 'Esperienza attivata con successo',
  something_went_wrong: 'Qualcosa è andato storto',

  language: 'Lingua',

  manual_code_heading: 'Hai scansionato un agami',
  manual_code_intro: 'Questo è Agami Route.',
  manual_code_explanation: "Per ascoltarlo, apri il codice dall'app Agami Route:",
  manual_code_step_1: "Apri Agami Route e scegli l'esperienza che contiene questo agami",
  manual_code_step_2: 'Premi "Inizia"',
  manual_code_step_3: 'Apri la sezione "Contenuti"',
  manual_code_step_4: 'Premi "SCANSIONA QR" e inquadra di nuovo questo codice',
  manual_code_qr_hint:
    'Se non trovi il pulsante "SCANSIONA QR", inserisci il codice manualmente e premi "Riproduci".',
  manual_code_label: 'Codice',
  manual_code_cta_get_app: "Scarica l'app",
  manual_code_cta_continue: "Continua nell'app",
  manual_code_footer: 'Per maggiori informazioni visita',

  aria_logo: 'Logo di Agami Route',
  aria_heading: 'Spiegazione della scansione del codice manuale',
  aria_explanation: 'Spiegazione su come usare il codice manuale scansionato',
  aria_button_get_app: "Scarica l'app Agami Route",
  aria_button_continue: "Continua nell'app Agami Route",

  credits: 'Crediti',
  noCredits: 'Non ci sono ancora crediti per questa esperienza',

  download_experience_title: "Scarica l'esperienza",
  download_experience_preparing: 'Preparazione del download...',
  download_experience_config: 'Download della configurazione...',
  download_experience_audio: "Download dell'audio...",
  download_experience_video: 'Download del video...',
  download_experience_credits: 'Download dei crediti...',
  download_experience_maps: 'Download delle mappe...',

  download_experience_error: "Errore durante il download dell'esperienza",
  download_experience_area_too_wide:
    "L'area della mappa di questa esperienza è troppo estesa per l'uso offline",
  download_experience_done: "Esperienza scaricata e pronta per l'uso offline!",
  download_experierience_config_error:
    "L'esperienza salvata presenta problemi di configurazione. Vai online e scaricala di nuovo",
  download_experience_not_allowed: 'La modalità offline non è consentita per questa esperienza',

  get_experience_data_error: "Errore durante il recupero dei dati dell'esperienza",
  get_experience_config_error: "Errore durante il recupero della configurazione dell'esperienza",

  session_expired_title: 'Sessione scaduta',
  session_expired_message: 'La tua sessione è scaduta. Accedi nuovamente per riprendere il tuo percorso.',
  session_expired_action: 'Accedi di nuovo',

  wrong_credentials: 'Credenziali errate',
  invalid_email: 'Email non valida',
  reset_password_instructions: 'Le istruzioni sono state inviate. Controlla la tua email',
};

export default it;
